import Box from '@mui/material/Box'
import Link from 'next/link'
import React, { useState } from 'react'
import { Typography } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { amber } from '@mui/material/colors'
import i18n from 'i18next'
import { styled } from '@mui/material/styles'
import k from './../../i18n/keys'
import AccountAvatar from './AccountAvatar'
import { useBackend } from '@/src/providers/BackendProvider'

const PREFIX = 'AccountSideBar'

const classes = {
  accDet: `${PREFIX}-accDet`,
  firHalf: `${PREFIX}-firHalf`,
  sndHalf: `${PREFIX}-sndHalf`,
  bullet: `${PREFIX}-bullet`,
  bullet1: `${PREFIX}-bullet1`,
  myOrder: `${PREFIX}-myOrder`,
  bullet2: `${PREFIX}-bullet2`,
  signout: `${PREFIX}-signout`,
  bullet3: `${PREFIX}-bullet3`,
  bullet4: `${PREFIX}-bullet4`,
  layoutDivider: `${PREFIX}-layoutDivider`,
  spacing: `${PREFIX}-spacing`,
  amberTy: `${PREFIX}-amberTy`,
  root: `${PREFIX}-root`
}

const Root = styled('div')(({ theme }) => {
  return {
    [`& .${classes.accDet}`]: {
      backgroundColor: '#FFFFFF',
      borderRadius: 12,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },

    [`& .${classes.firHalf}`]: {
      padding: '12px 0px',
      width: '100%',
      height: '50%',
      [theme.breakpoints.up('xl')]: {
        padding: '18px 0px'
      }
    },

    [`& .${classes.sndHalf}`]: {
      display: 'flex',
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px 0px',
      height: '50%',
      backgroundColor: '#ffffff',
      width: '100%',
      cursor: 'pointer',
      borderRadius: 12,
      textAlign: i18n.t(k.CENTER),
      [theme.breakpoints.up('xl')]: {
        padding: '18px 0px'
      }
    },

    [`& .${classes.bullet}`]: {
      position: 'absolute',
      right: 10,
      transform: 'translateY(-50%)',
      flexShrink: '0',
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: amber[600]
    },

    [`& .${classes.root}`]: {
      display: 'flex',
      flexDirection: 'column',
      width: '288px',
      marginRight: '24px'
    },

    [`& .${classes.bullet1}`]: {
      color: amber[600],
      margin: '0px 8px',
      fontSize: 40,
      lineHeight: 0.4
    },

    [`& .${classes.myOrder}`]: {
      padding: '12px 0px',
      width: '100%',
      height: '100%',
      [theme.breakpoints.up('xl')]: {
        padding: '18px 0px'
      }
    },

    [`& .${classes.bullet2}`]: {
      color: amber[600],
      position: 'absolute',
      left: '32%',
      fontSize: 40,
      marginTop: '-17px'
    },

    [`& .${classes.signout}`]: {
      padding: '12px 0px',
      width: '100%',
      height: '100%',
      [theme.breakpoints.up('xl')]: {
        padding: '18px 0px'
      }
    },

    [`& .${classes.bullet3}`]: {
      color: amber[600],
      position: 'absolute',
      left: '34%',
      fontSize: 40,
      marginTop: '-17px'
    },

    [`& .${classes.bullet4}`]: {
      color: amber[600],
      position: 'absolute',
      left: '22%',
      fontSize: 40,
      marginTop: '-17px'
    },

    [`& .${classes.layoutDivider}`]: {
      width: '100%',
      borderColor: theme.palette.grey[200]
    },

    [`& .${classes.layout}`]: {
      width: '288px',
      display: 'flex',
      flexDirection: 'column'
    },

    [`& .${classes.spacing}`]: {
      width: 0,
      height: 0,
      position: 'relative'
    },

    [`& .${classes.amberTy}`]: {
      textAlign: 'center',
      paddingTop: 11,
      display: 'block',
      color: theme.palette.primary[500]
    }
  }
})

// const AmberTypography = styled(Typography)({
//   color: amber[600]
// })

const AccountSideBar = ({ setCurrentView, currentView, prefittingStat }) => {
  const { userSignOut, userDetails } = useBackend()
  const [displayRedDot, setDisplayRedDot] = useState(true)
  const info = {
    firstName: userDetails.first_name,
    lastName: userDetails.last_name,
    year: userDetails.birth_year,
    gender: userDetails.gender,
    state: userDetails.state,
    email: userDetails.username
  }

  const windowView = currentView

  const signOutOnClick = () => {
    userSignOut()
    location.href = '/'
  }

  return (
    <Root>
      <div className={classes.root}>
        <AccountAvatar info={info} />
        <Box
          bgcolor="#ffffff"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          mt={2}
          borderRadius={12}
        >
          <div
            className={classes.sndHalf}
            onClick={() => {
              setCurrentView('detail')
              window.location.hash = ''
              setDisplayRedDot(true)
            }}
            style={{
              borderRadius: '12px',
              backgroundColor: windowView === 'detail' ? '#415670' : '#ffffff'
            }}
          >
            <div className={classes.spacing} />
            <Typography
              id="account_account_details"
              display="inline"
              variant="Body2"
              style={{
                cursor: 'pointer',
                fontSize: 18,
                textAlign: 'center',
                color: windowView === 'detail' ? '#ffffff' : '#26201F'
              }}
            >
              {i18n.t(k.ACCOUNT_DETAILS1)}
            </Typography>
          </div>
          <div
            className={classes.sndHalf}
            onClick={() => {
              setCurrentView('service')
              window.location.hash = '#service'
              setDisplayRedDot(false)
            }}
            style={{
              borderRadius: '12px',
              backgroundColor: windowView === 'service' ? '#415670' : '#ffffff'
            }}
          >
            <div className={classes.spacing} />
            <Typography
              id="account_service_center"
              variant="Body2"
              style={{
                cursor: 'pointer',
                fontSize: 18,
                textAlign: 'center',
                color: windowView === 'service' ? '#ffffff' : '#26201F'
              }}
            >
              Service Center
            </Typography>
            {displayRedDot && !prefittingStat && (
              <div
                style={{
                  width: '10px',
                  height: '10px',
                  backgroundColor: theme.palette.error[400],
                  borderRadius: '100%',
                  position: 'absolute',
                  right: 'calc(50% - 72px)',
                  top: '25%'
                }}
              />
            )}
          </div>
        </Box>
        {/* TODO: uncomment this part when upload audiogram is ready */}
        <Box
          bgcolor="#ffffff"
          borderRadius="12px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          mt={2}
        />
        <Box
          sx={{
            bgcolor: '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '0px',
            borderRadius: '12px',
            width: '100%'
          }}
        >
          <div
            className={classes.sndHalf}
            onClick={() => {
              setDisplayRedDot(true)
              setCurrentView('orders')
              window.location.hash = '#orders'
            }}
            style={{
              backgroundColor: windowView === 'orders' ? '#415670' : '#ffffff'
            }}
          >
            <Typography
              id="account_my_orders"
              variant="Body2"
              style={{
                cursor: 'pointer',
                fontSize: 18,
                textAlign: 'center',
                color: windowView === 'orders' ? '#ffffff' : '#26201F'
              }}
            >
              My Orders
            </Typography>
          </div>
        </Box>
        <Box
          bgcolor="white"
          borderRadius="12px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          marginTop="72px"
        >
          <div
            className={classes.sndHalf}
            onClick={signOutOnClick}
            style={{ cursor: 'pointer', borderRadius: '12px', width: '100%' }}
          >
            <div className={classes.spacing} />
            <Typography
              id="account_log_out"
              variant="Body2"
              style={{
                cursor: 'pointer',
                fontSize: 18,
                textAlign: 'center',
                color: windowView === 'signout' ? '#506A8A' : '#636363'
              }}
            >
              {i18n.t(k.SIGN_OUT)}
            </Typography>
          </div>
        </Box>
        <div>
          <Link prefetch={false} href="/FAQ">
            <Typography
              id="account_need_help"
              variant="Link"
              className={classes.amberTy}
            >
              {i18n.t(k.NEED_HELP)}
            </Typography>
          </Link>
        </div>
      </div>
    </Root>
  )
}

export default AccountSideBar
